import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import CloseIcon from "@material-ui/icons/Close";
import { modalAtom } from "../containers/App/App.state";

const useModalStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const Modal = () => {
  const classes = useModalStyles();
  const { content, title } = useRecoilValue(modalAtom);
  const resetModal = useResetRecoilState(modalAtom);

  function handleClose() {
    resetModal();
  }

  return (
    <Dialog open={Boolean(title || content)} keepMounted onClose={handleClose}>
      <DialogTitle disableTypography className={classes.root}>
        <Typography variant="h6">{title || " "}</Typography>
        <IconButton
          size="small"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      {/* <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleClose} color="primary">
          Save
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default Modal;
